/**
 * FeWo·Monitor Wortmarke — konsistent mit dem Onepager-Branding
 * (Primärfarbe, Akzent-Punkt). Größe über `className` (z. B. text-2xl).
 */
export default function Wordmark({ className = '' }: { className?: string }) {
  return (
    <span className={`font-extrabold select-none whitespace-nowrap text-primary-900 ${className}`}>
      FeWo<span className="text-warning-500">·</span>Monitor
    </span>
  );
}
